<template>
  <el-card shadow="never" class="l-main-card"
    v-loading="loading_export"
    element-loading-text="拼命导出中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="l-table-place">
        <div class="flex flex-warp">
          <div class="flexs items-center ivu-mt ivu-mr">
            <p class="mr1">培训项目</p>
            <el-input
              placeholder="请输入培训项目名称"
              v-model="search_data.site_name"
              class="input-with-select"
              style="width: 80%;"
            >
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
          </div>
          <div class="flexs items-center ivu-mt ivu-mr">
            <p class="mr1">分项名称</p>
            <el-input
              placeholder="请输入分项名称"
              v-model="search_data.material_name"
              class="input-with-select"
              style="width: 80%;"
            >
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
          </div>
          <div class="flexs items-center ivu-mt ivu-mr">
            <p class="mr1">分类</p>
            <el-cascader v-model="search_data.type_id" :options="tree_node" :props="{ checkStrictly: true }" clearable style="width:500px;"/>
            </el-cascader>
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </div>

        </div>    
          
    </div>
    
    <div class="l-table-toolbar">
      <l-auth-button class="ivu-mr" type="primary" auth="cert_batch_gen_btn" @click="handlePrint()"> 批量导出结业证书 </l-auth-button>
      <div class="l-simple-search-container" style="float: right;">
        <el-input placeholder="请输入编码或名称" v-model="search_data.keywords" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
      <el-table-column fixed prop="index" label="序号" width="60"> </el-table-column>

      <el-table-column prop="site_name" label="培训项目" min-width="120"></el-table-column>

      <!-- <el-table-column prop="material_name" label="分项名称" min-width="300">
        <template slot-scope="{ row }">
          <a style="color: cornflowerblue;" @click="showInfo(row.id)" v-if="row.grade != 3">{{row.material_name}}</a>
           <a v-else>{{row.material_name}}</a>
        </template>
      </el-table-column>
      
      <el-table-column prop="material_specification_name" label="培训方式" min-width="120"></el-table-column>
      
      <el-table-column prop="material_quantity" label="培训时长" min-width="180">
          <template slot-scope="{ row }">
              <el-input v-model="row.material_quantity" autocomplete="off" placeholder="请输入时长" 
                  v-show="row.show" />
              <span v-show="!row.show">{{parseFloat(row.material_quantity)}}</span>
          </template>
      </el-table-column> -->
      
      <el-table-column prop="train_state" label="学习状态" min-width="80"></el-table-column>
      
      <el-table-column prop="inspecter_name" label="学员" min-width="80"></el-table-column>

      <el-table-column prop="action_at" label="学习时间" width="180"> </el-table-column>
      
      <el-table-column prop="verifier_name" label="审核人" width="180"> </el-table-column>
      
      <el-table-column prop="verify_at" label="审核时间" width="180"> </el-table-column>
        <el-table-column prop="issuer_name" label="发放证书人" width="180"> </el-table-column>
        <el-table-column prop="issued_at" label="发放证书时间" width="180"> </el-table-column>
        
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="{ row }">
            <!-- <l-auth-text-button type="primary" auth="material_inspect_edit_btn" @click="edit(row,'edit')" v-show="!row.show">
                <i class="el-icon-edit"></i>编辑</l-auth-text-button>
            <l-auth-text-button type="primary" auth="material_inspect_edit_btn" @click="edit(row,'save')" v-show="row.show">
                <i class="el-icon-edit"></i>保存</l-auth-text-button>
            <l-auth-text-button type="primary" auth="material_inspect_edit_btn" @click="edit(row,'cancel')" v-show="row.show">
                <i class="el-icon-edit"></i>取消</l-auth-text-button> -->
            <l-auth-text-button type="danger" auth="cert_ind_gen_btn" @click="genCert(row.id)">
                <i class="el-icon-edit"></i>生成证书</l-auth-text-button>
            <!-- <span class="l-action-separator">|</span>
            <l-auth-text-button type="danger" auth="material_inspect_del_btn" @click="del(row.id)">
                <i class="el-icon-delete"></i>删除证书</l-auth-text-button> -->
          </template>
        </el-table-column>

    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="检查详情" width="1100px">
      <l-inspection-info @on-success="onAddSucess" :visible.sync="info_visible" :id="info_id"></l-inspection-info>
    </l-dialog>

  </el-card>
</template>

<script>
import { MATERIAL_LEVEL, STATE_NAMES, LEVEL } from '../public/basis.js';
// import Edit from "./Edit.vue";
import Info from "./Info.vue";
// import Import from "./Import.vue";
import Vue from "vue";
export default {
  components: {
    // [Edit.name]: Edit,
    [Info.name]: Info,
    // [Import.name]: Import,

  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      info_visible: false,
      edit_visible: false, //是否显示编辑
      import_visible:false,
      edit_id: 0,
      info_id: 0,
      MATERIAL_LEVEL: MATERIAL_LEVEL,
      STATE_NAMES: STATE_NAMES,
      LEVEL: LEVEL,
      //默认场所数据  改场所为  公共场所
      moduler: 1,
      for_verify: 0,
      for_issue: 0,
      for_export: 1,
      //搜索
      //分类
      tree_node: [
      
      ],
      
      search_visible: false,
      search_data: {
        keywords: "",
        material_code: "",
        material_name: "",
        site_name: "",
        type_id: [],
        // management_state: "",
        
      },
      rel_search_data: {},
      show_more_search: false,
      loading_export: false,
      multipleSelection: [],//选择
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    //获取数据
    getList() {
      this.loading = true;
      
      // let rel_search_data = Object.assign({}, this.rel_search_data);
      // console.log(rel_search_data.type_id);
      // if (rel_search_data.type_id != undefined && typeof rel_search_data.type_id != "number") {
      //   const type_id_len = rel_search_data.type_id.length;
      //   rel_search_data.type_id = rel_search_data.type_id[type_id_len - 1];
      //   console.log(rel_search_data.type_id);
      // }

      if (this.rel_search_data.type_id != undefined && typeof this.rel_search_data.type_id != "number") {
        const type_id_len = this.rel_search_data.type_id.length;
        this.rel_search_data.type_id = this.rel_search_data.type_id[type_id_len - 1];
        console.log(this.rel_search_data.type_id);
      }
      
      this.$_invoke("materialInspect_getList", {
        page: this.page,
        page_size: this.page_size,
        moduler: this.moduler,
        for_export: this.for_export,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
          this.tree_node = ret.tree_node;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    //选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    
    //显示详情和添加隐患描述和解决
    showInfo(id) {

      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },

    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //修改密码成功回调
    onChangePwdSuccess() {
      this.show_change_pwd = false;
    },

    
    //显示导入
    onImportSuccess() {
      this.import_visible = false;
      this.getList();
    },
    
    //编辑/保存，改变状态
    edit(row, mode) {
        // console.log(row.show);
        if (mode == "edit") {
            row.show = true;
        } else {
            row.show = false;
        }
    
        //save
        if (mode == "save") {
            this.submitting = true;

            this.$_invoke('materialInspect_updateInspect', {id: row.id, 
                                                            material_quantity: row.material_quantity, 
                                                            producted_at: row.producted_at})
                .then(() => {
            this.$_msg.success('修改检查记录成功');
            this.getList();
          }).finally(() => {
            this.submitting = false;
          })
        }
    },
    
    //生成结业证书
    genCert(id) {
        this.submitting = true;

        this.$_invoke('materialInspect_generateCertificate', {id: id})
            .then(ret => {
              window.open(ret);
            })
            .finally(() => {
              this.submitting = false;
            });
    },
    
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`materialInspect_deleteInspect`, { id }).then((ret) => {
            if (ret != true) {
                this.$_msg.success("删除失败");
            } else {
                this.$_msg.success("删除成功");
                this.getList();
            }
          });
        })
        .catch(() => { });
    },
    
    //审核
    handleVerify() {
        if(this.multipleSelection.length==0){
          this.$message.error('请先选择要审核的记录');
          return;
        }
        const select_record_id=this.multipleSelection.map((v)=>v["id"]);
        
        
      this.loading_export = true;

      this.$_invoke('materialInspect_verify', {
            page: this.page,
            page_size: this.page_size,
            moduler: this.moduler,
            ...this.rel_search_data,
            record_id:select_record_id 
          })
        .then((ret) => {
            if (ret != true) {
                this.$_msg.success("审核失败");
            } else {
                this.$_msg.success("审核成功");
                this.getList();
            }
        })
        .finally(() => {
          this.loading_export = false;
        });
    },
    //导出
    // handlePrint() {
    //     if(this.multipleSelection.length==0){
    //       this.$message.error('请先选择要生成的记录');
    //       return;
    //     }
    //     const select_record_id=this.multipleSelection.map((v)=>v["id"]);
        
        
    //   this.loading_export = true;
    
    //   this.$_invoke('materialInspect_generateCertificate', {
    //         page: this.page,
    //         page_size: this.page_size,
    //         moduler: this.moduler,
    //         ...this.rel_search_data,
    //         record_id:select_record_id 
    //       })
    //     .then((ret) => {
    //         if (ret != true) {
    //             this.$_msg.success("审核失败");
    //         } else {
    //             this.$_msg.success("审核成功");
    //             this.getList();
    //         }
    //     })
    //     .finally(() => {
    //       this.loading_export = false;
    //     });
    // },
  },
};
</script>
